"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HERMIS_ERROR__SIGNING__MESSAGE_FAILED = exports.HERMIS_ERROR__TRANSACTION__SEND_FAILED = exports.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED = exports.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED = exports.isHermisError = exports.HermisError = exports.WalletNotSelectedError = void 0;
// src/utils/errors.ts
var errors_1 = require("@hermis/errors");
/**
 * Error thrown when no wallet is selected
 * @deprecated Use HermisError with HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED instead
 */
var WalletNotSelectedError = /** @class */ (function (_super) {
    __extends(WalletNotSelectedError, _super);
    function WalletNotSelectedError(message, error) {
        if (message === void 0) { message = 'No wallet selected'; }
        var _this = _super.call(this, errors_1.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED, {}, error) || this;
        _this.name = 'WalletNotSelectedError';
        return _this;
    }
    return WalletNotSelectedError;
}(errors_1.HermisError));
exports.WalletNotSelectedError = WalletNotSelectedError;
// Re-export commonly used error types and codes for convenience
var errors_2 = require("@hermis/errors");
Object.defineProperty(exports, "HermisError", { enumerable: true, get: function () { return errors_2.HermisError; } });
Object.defineProperty(exports, "isHermisError", { enumerable: true, get: function () { return errors_2.isHermisError; } });
Object.defineProperty(exports, "HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED", { enumerable: true, get: function () { return errors_2.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED; } });
Object.defineProperty(exports, "HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED", { enumerable: true, get: function () { return errors_2.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED; } });
Object.defineProperty(exports, "HERMIS_ERROR__TRANSACTION__SEND_FAILED", { enumerable: true, get: function () { return errors_2.HERMIS_ERROR__TRANSACTION__SEND_FAILED; } });
Object.defineProperty(exports, "HERMIS_ERROR__SIGNING__MESSAGE_FAILED", { enumerable: true, get: function () { return errors_2.HERMIS_ERROR__SIGNING__MESSAGE_FAILED; } });
